import React from 'react';
import { Element } from 'react-scroll';
import Header from '../Header/index';
import Footer from '../Footer/index';
import About from '../About/index';
import Services from '../Services/index';
import Contact from '../Contact/index';
import Doctors from '../Doctors';
import Reviews from '../Feedbacks';
import Gallery from '../../Gallary';
import Personals from '../../Personals';

const MainLayout = () => {
    return (
        <>
            <Header />
            {/* <Element name="home"><Home /></Element> */}
            <Element name="about"><About /></Element>
            <Element name="personals"><Personals /></Element>
            <Element name="doctor"><Doctors /></Element>
            <Element name="services"><Services /></Element>
            <Element name="gallary"><Gallery /></Element>
            <Element name="reviews"><Reviews/></Element>
            <Element name="contact"><Contact /></Element>
            <Footer />
        </>
    );
};

export default MainLayout;
